

import IconRedDanger from "@/assets/svg/IconRedDanger";
import IconSunYellowStar from "@/assets/svg/IconSunYellowStar";
import DwellingInterventionHistoryTableComponent from "@/modules/dwelling/components/sheet/DwellingInterventionHistoryTableComponent.tsx";


interface DwellingInterventionHistoryProps {
  dwellingId: string;
}

const DwellingInterventionHistory: React.FC<
  DwellingInterventionHistoryProps
> = ({ dwellingId }) => {
  return (
    <div className="bg-container dwelling_interventions d-flex flex-column gap-4">
      <span className="dwelling_title">Historiques des interventions</span>
      <div className="d-flex flex-wrap gap-5">
        <div className="d-flex flex-column me-5">
          <DwellingInterventionHistoryTableComponent dwellingId={dwellingId} />
        </div>
        <div className="d-flex flex-column gap-5 ms-5">
          <div className="d-flex gap-3">
            <IconRedDanger />
            <div>
              <div className="dwelling_interventions_infos-title">
                Infos sur le classement inconnu pour le DPE
              </div>
              <div className="dwelling_interventions_infos-subtitle">
                A prévoir
              </div>
            </div>
          </div>
          <div className="d-flex gap-3">
            <IconSunYellowStar />
            <div>
              <div className="dwelling_interventions_infos-title">
                Infos sur la location inconnu
              </div>
              <div className="dwelling_interventions_infos-subtitle">
                A prévoir
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DwellingInterventionHistory;
